import React from "react";

import { SubContractorBadge } from "../../../SubContractorBadge";
import { TeamMemberComponent } from "./styled";

interface ITeamMember {
  name: string;
  isSubcontractor: boolean;
}

export const TeamMember = ({ isSubcontractor, name }: ITeamMember) => {
  return (
    <TeamMemberComponent>
      <span>{name}</span>
      {isSubcontractor && <SubContractorBadge />}
    </TeamMemberComponent>
  );
};
